import axiosInstance from '@/services/axiosInstance'

async function getPricePasses (types = 'P-AUX|P-DEP|P-PAS') {
  const data = {
    filter: [
      { Field: 'CodConcepto', Criteria: types }
    ]
  }
  const req = {
    url: '/rgcc-services/conceptofacturacion/ReadMultiple',
    method: 'POST',
    data
  }

  const res = await axiosInstance(req)

  return res.data?.ReadMultiple_Result?.ConceptoFacturacion || null
}

export {
  getPricePasses
}
